import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Profile.css";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("editProfile");
  const [profileData, setProfileData] = useState({});
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [formData, setFormData] = useState({});
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });
  const [fetchingPassword, setFetchingPassword] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  // Fetch profile data on component mount
  useEffect(() => {
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const response = await axios.post('https://server.majestyfx.com/admin_getprofile.php', {
        email: "admin@gmail.com"
      });
      
      if (response.data.success) {
        setProfileData(response.data.data);
        setFormData(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching profile data:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      setUpdating(true);
      const updateData = {
        client_index: parseInt(formData.client_index) || 1,
        email: formData.email || '',
        username: formData.username || '',
        dob: formData.dob || '',
        number: formData.number || '',
        address: formData.address || '',
        website: formData.website || '',
        company_name: formData.company_name || '',
        company_address: formData.company_address || '',
        company_number: formData.company_number || '',
        db_prefex: formData.db_prefex || 'db1',
        profile_pic: formData.profile_pic || 'profile1.png',
        country: formData.country || '',
        dial_code: formData.dial_code || '+91',
        zipcode: formData.zipcode || '',
        city: formData.city || '',
        state: formData.state || ''
      };
      
      const response = await axios.post('https://server.majestyfx.com/admin_updateprofile.php', updateData);
      
      if (response.data.success) {
        alert('Profile updated successfully!');
        fetchProfileData(); // Refresh data
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Error updating profile');
    } finally {
      setUpdating(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePasswordChange = (field, value) => {
    setPasswordData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const fetchCurrentPassword = async () => {
    try {
      setFetchingPassword(true);
      const response = await axios.post('https://server.majestyfx.com/admin_getpass.php', {
        email: "admin@gmail.com"
      });
      
      if (response.data.success) {
        setPasswordData(prev => ({
          ...prev,
          currentPassword: response.data.password
        }));
        alert('Current password fetched successfully!');
      }
    } catch (error) {
      console.error('Error fetching password:', error);
      alert('Error fetching current password');
    } finally {
      setFetchingPassword(false);
    }
  };

  const changePassword = async () => {
    try {
      if (passwordData.newPassword !== passwordData.confirmNewPassword) {
        alert('New password and confirm password do not match!');
        return;
      }

      if (!passwordData.currentPassword || !passwordData.newPassword) {
        alert('Please fill all password fields!');
        return;
      }

      setChangingPassword(true);
      const response = await axios.post('https://server.majestyfx.com/admin_changepassword.php', {
        email: "admin@gmail.com",
        current_password: passwordData.currentPassword,
        new_password: passwordData.newPassword,
        confirm_new_password: passwordData.confirmNewPassword
      });
      
      if (response.data.success) {
        alert('Password updated successfully!');
        setPasswordData({
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: ''
        });
      }
    } catch (error) {
      console.error('Error changing password:', error);
      alert('Error changing password');
    } finally {
      setChangingPassword(false);
    }
  };

  return (
    <div className="profile-page">
      <div className="page-header">
        <h1>Profile</h1>
        <div className="breadcrumb">
          <span className="breadcrumb-link">Home</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">User Profile</span>
        </div>
      </div>

      <div className="profile-container">
        {/* Left Side - Profile Card */}
        <div className="profile-sidebar">
          <div className="profile-card">
            <div className="profile-avatar">
              <img
                src="/avatar.jpg"
                alt="Profile Avatar"
                className="avatar-image"
              />
            </div>
            <h3 className="profile-name">Asdaque Riffat</h3>
            
            <div className="profile-stats">
              <div className="stat-item">
                <span className="stat-label">Age</span>
                <span className="stat-value age-badge">0</span>
              </div>
              
              <div className="stat-item">
                <span className="stat-label">Country</span>
                <span className="stat-value country-badge">Azerbaijan</span>
              </div>
              
              <div className="stat-item">
                <span className="stat-label">Trading Accounts</span>
                <span className="stat-value trading-badge">1</span>
              </div>
              
              <div className="stat-item">
                <span className="stat-label">Wallet</span>
                <span className="stat-value wallet-badge">$0.00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Tabs & Content */}
        <div className="profile-content">
          {/* Tabs */}
          <div className="profile-tabs">
            <button
              className={activeTab === "editProfile" ? "tab-btn active" : "tab-btn"}
              onClick={() => setActiveTab("editProfile")}
            >
              Edit Profile
            </button>
            <button
              className={activeTab === "kyc" ? "tab-btn active kyc-pending" : "tab-btn kyc-pending"}
              onClick={() => setActiveTab("kyc")}
            >
              KYC <span className="pending-badge">Pending</span>
            </button>
            <button
              className={activeTab === "changePassword" ? "tab-btn active" : "tab-btn"}
              onClick={() => setActiveTab("changePassword")}
            >
              Change Password
            </button>
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === "editProfile" && (
              <div className="edit-profile-content">
                {loading ? (
                  <div className="loading">Loading profile data...</div>
                ) : (
                  <>
                    {/* Username Field */}
                    {formData.username && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Username</label>
                        <input
                          type="text"
                          value={formData.username || ''}
                          onChange={(e) => handleInputChange('username', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Email Field */}
                    {formData.email && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Email</label>
                        <input
                          type="email"
                          value={formData.email || ''}
                          onChange={(e) => handleInputChange('email', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Gender Field */}
                    {formData.gender && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Gender</label>
                        <input
                          type="text"
                          value={formData.gender || ''}
                          onChange={(e) => handleInputChange('gender', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Date of Birth Field */}
                    {formData.dob && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Date of Birth</label>
                        <input
                          type="date"
                          value={formData.dob || ''}
                          onChange={(e) => handleInputChange('dob', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Phone Number Field */}
                    {formData.number && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Phone Number</label>
                        <input
                          type="tel"
                          value={formData.number || ''}
                          onChange={(e) => handleInputChange('number', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Address Field */}
                    {formData.address && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Address</label>
                        <input
                          type="text"
                          value={formData.address || ''}
                          onChange={(e) => handleInputChange('address', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Website Field */}
                    {formData.website && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Website</label>
                        <input
                          type="url"
                          value={formData.website || ''}
                          onChange={(e) => handleInputChange('website', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Company Name Field */}
                    {formData.company_name && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Company Name</label>
                        <input
                          type="text"
                          value={formData.company_name || ''}
                          onChange={(e) => handleInputChange('company_name', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Company Address Field */}
                    {formData.company_address && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Company Address</label>
                        <input
                          type="text"
                          value={formData.company_address || ''}
                          onChange={(e) => handleInputChange('company_address', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Company Number Field */}
                    {formData.company_number && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Company Number</label>
                        <input
                          type="text"
                          value={formData.company_number || ''}
                          onChange={(e) => handleInputChange('company_number', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Country Field */}
                    {formData.country && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Country</label>
                        <input
                          type="text"
                          value={formData.country || ''}
                          onChange={(e) => handleInputChange('country', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* City Field */}
                    {formData.city && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">City</label>
                        <input
                          type="text"
                          value={formData.city || ''}
                          onChange={(e) => handleInputChange('city', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* State Field */}
                    {formData.state && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">State</label>
                        <input
                          type="text"
                          value={formData.state || ''}
                          onChange={(e) => handleInputChange('state', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    {/* Zipcode Field */}
                    {formData.zipcode && (
                      <div className="form-row-horizontal">
                        <label className="form-label-left">Zipcode</label>
                        <input
                          type="text"
                          value={formData.zipcode || ''}
                          onChange={(e) => handleInputChange('zipcode', e.target.value)}
                          className="form-input-right"
                        />
                      </div>
                    )}
                    
                    <button 
                      type="button" 
                      className="save-changes-btn"
                      onClick={updateProfile}
                      disabled={updating}
                    >
                      {updating ? 'Updating...' : 'Save Changes'}
                    </button>
                  </>
                )}
              </div>
            )}

            {activeTab === "kyc" && (
              <div className="kyc-content">
                <div className="form-row">
                  <div className="form-group half-width">
                    <label>Document Number</label>
                    <input
                      type="text"
                      className="form-input"
                    />
                    <small className="form-help">Government-issued document number</small>
                  </div>
                  <div className="form-group half-width">
                    <label>Address</label>
                    <textarea
                      className="form-textarea"
                      placeholder="Please enter your address"
                    ></textarea>
                  </div>
                </div>
                
                <div className="form-group">
                  <label>Selfie holding ID document</label>
                  <div className="file-upload">
                    <input type="file" id="selfie" className="file-input" />
                    <label htmlFor="selfie" className="file-label">
                      <span>Choose File</span>
                      <button type="button" className="browse-btn">Browse</button>
                    </label>
                  </div>
                  <small className="form-help">Upload a Selfie holding your id card in JPG, PNG, PDF, or DOC format. Max size: 50MB.</small>
                </div>
                
                <div className="form-row">
                  <div className="form-group half-width">
                    <label>Front Side</label>
                    <div className="file-upload">
                      <input type="file" id="front" className="file-input" />
                      <label htmlFor="front" className="file-label">
                        <span>Choose File</span>
                        <button type="button" className="browse-btn">Browse</button>
                      </label>
                    </div>
                    <small className="form-help">Upload a color copy of identification (Front Side) in JPG, PNG, PDF, or DOC format. Max size: 50MB.</small>
                  </div>
                  <div className="form-group half-width">
                    <label>Back Side</label>
                    <div className="file-upload">
                      <input type="file" id="back" className="file-input" />
                      <label htmlFor="back" className="file-label">
                        <span>Choose File</span>
                        <button type="button" className="browse-btn">Browse</button>
                      </label>
                    </div>
                    <small className="form-help">Upload a color copy of identification (Back Side) in JPG, PNG, PDF, DOC, or DOCX format. Max size: 50MB.</small>
                  </div>
                </div>
                
                <div className="kyc-info">
                  <p>Attaching your proof of identification and address documents will fast the process of opening your trading account. You may also upload your proof of identification and address via <strong>nCRM</strong> at a later stage.</p>
                  <p>Documents required must be in JPG, JPEG, PNG, PDF, DOC, or DOCX format and should be up to 50MB in size.</p>
                </div>
                
                <div className="form-group">
                  <label>Proof of address</label>
                  <div className="file-upload">
                    <input type="file" id="address" className="file-input" />
                    <label htmlFor="address" className="file-label">
                      <span>Choose File</span>
                      <button type="button" className="browse-btn">Browse</button>
                    </label>
                  </div>
                  <small className="form-help">Recently issued Bank Statement or Utility bill mentioning your name and address, the document should not be older than 3 months.</small>
                   <small className="form-help">Documents required must be in JPG, JPEG, PNG, PDF, DOC, or DOCX format and should be maximum 50 MB in size.</small>
                 </div>
                 
                 <button type="button" className="save-changes-btn">
                   Save Changes
                 </button>
               </div>
             )}

            {activeTab === "changePassword" && (
              <div className="change-password-content">
                <div className="form-group">
                  <label>Current Password</label>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <input
                      type="password"
                      placeholder="Current Password"
                      className="form-input"
                      value={passwordData.currentPassword}
                      onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
                    />
                    <button 
                      type="button" 
                      className="fetch-password-btn"
                      onClick={fetchCurrentPassword}
                      disabled={fetchingPassword}
                      style={{ 
                        padding: '8px 16px', 
                        backgroundColor: '#007bff', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '4px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {fetchingPassword ? 'Fetching...' : 'Fetch Current'}
                    </button>
                  </div>
                </div>
                
                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    placeholder="New Password"
                    className="form-input"
                    value={passwordData.newPassword}
                    onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                  />
                </div>
                
                <div className="form-group">
                  <label>Confirm New Password</label>
                  <input
                    type="password"
                    placeholder="Confirm New Password"
                    className="form-input"
                    value={passwordData.confirmNewPassword}
                    onChange={(e) => handlePasswordChange('confirmNewPassword', e.target.value)}
                  />
                </div>
                
                <button 
                  type="button" 
                  className="save-changes-btn"
                  onClick={changePassword}
                  disabled={changingPassword}
                >
                  {changingPassword ? 'Changing Password...' : 'Change Password'}
                </button>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>

   
  
  );
};

export default Profile;
